import { h } from 'preact';

const EmptyPin = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#fff" role="img" {...props}>
			<path d="M8,1 C6.464,1 4.929,1.565 3.757,2.697 C1.414,4.959 1.414,8.627 3.757,10.89 C3.762,10.894 3.766,10.898 3.771,10.902 L3.771,10.917 L8,15 L12.191,10.953 L12.191,10.938 C12.208,10.922 12.226,10.906 12.242,10.89 C14.586,8.627 14.586,4.959 12.242,2.697 C11.071,1.565 9.535,1 8,1 M8,2 C9.342,2 10.603,2.503 11.548,3.416 C12.484,4.32 13,5.52 13,6.793 C13,8.067 12.484,9.266 11.548,10.17 L11.505,10.211 L11.191,10.521 L11.191,10.529 L8,13.61 L4.758,10.479 L4.757,10.465 L4.452,10.17 C3.516,9.266 3,8.067 3,6.793 C3,5.52 3.516,4.32 4.452,3.416 C5.398,2.503 6.658,2 8,2" />
			<path d="M8,5 C7.448,5 7,5.448 7,6 C7,6.552 7.448,7 8,7 C8.552,7 9,6.552 9,6 C9,5.448 8.552,5 8,5" />
		</svg>
	);
};

export default EmptyPin;
